import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { translate } from "../../components/Language/Translate";
import { Col, Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
// import { useDispatch} from "react-redux";
import Spinner from "../../components/Spinner";
// import FormCruiseNotFoundSchema from "./CruiseProposalSchema";
import FormFields from "../FormFields";
// import CruiseProposalSchema from "./CruiseProposalSchema";
import CompanySchema from "./CompanySchema";
// import {addCruiseProposalOnAPI} from '../../actions/cruiseProposals'
import FormValidation from "../Validation/FormValidation";
// import { simpleRequest } from "../../newForms2/simpleRequest";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompaniesFromAPI } from "../../actions/companies";
import { updateCompanyOnAPI } from "../../actions/currentCompany";
// import { addCompanyOnAPI } from "../../actions/companies";

const CompanyEdit = ({ backFunc }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [variables, setVariables] = useState({});
  const [fieldSettings, setFieldSettings] = useState({});
  const [success, setSuccess] = useState(false);
  const [serverError, setServerError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  // const history = useHistory();
  const currentCompany = useSelector((st) => st.currentCompany);
  const dispatch = useDispatch();

  console.log("inside CompanyEdit in newforms2", variables);

  useEffect(() => {
    console.log("inside useEffect");
    const fetch = () => {
      const sets = new CompanySchema();
      (() => setFieldSettings({ ...sets.fields }))();
      const vars = {};
      Object.keys(sets.fields).forEach((k) => (vars[k] = currentCompany[k]));
      (() => setVariables({ ...vars }))();
      (() => setIsLoading(false))();
    };
    if (isLoading) fetch();
  }, [isLoading, setFieldSettings, setVariables, setIsLoading, currentCompany]);

  if (isLoading) return <Spinner />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formValidation = new FormValidation({ fieldSettings, variables });
    if (!formValidation.valid) return;
    dispatch(updateCompanyOnAPI(currentCompany.id, { ...variables }));
    dispatch(fetchCompaniesFromAPI());
    setSuccess(true);
    backFunc();
  };
  const props = {
    fieldSettings,
    variables,
    setVariables,
    fieldErrors,
    setFieldErrors,
    serverError,
  };

  return (
    <div
      className="m-3 p-3"
      style={{ border: "1px solid grey", borderRadius: "5px" }}
    >
      <h4>{currentCompany.name}</h4>
      <h5>Schule bearbeiten</h5>
      {!success && (
        <Form onSubmit={(e) => handleSubmit(e)}>
          <FormFields props={props} />
          <Form.Row>
            <Col>
              <Button className="col-12 btn btn-info" type="submit">
                {translate("Submit")}
              </Button>
            </Col>
            <Col>
              <Button className="col-12 btn btn-secondary" onClick={backFunc}>
                {translate("Cancel")}
              </Button>
            </Col>
          </Form.Row>
        </Form>
      )}
      {success && <h5>Schule erfolgreich aktualisiert.</h5>}
    </div>
  );
};
export default CompanyEdit;
